//////////////////////This is import for API Call/////////////
import adsService from "../services/adsService";

export const GET_ADS = "GET_ADS";
export const GET_ADS_SUCCESS = "GET_ADS_SUCCESS";
export const GET_ADS_ERROR = "GET_ADS_ERROR";

export const CREATE_OR_UPDATE_ADS = "CREATE_OR_UPDATE_ADS";
export const CREATE_OR_UPDATE_ADS_SUCCESS = "CREATE_OR_UPDATE_ADS_SUCCESS";
export const CREATE_OR_UPDATE_ADS_ERROR = "CREATE_OR_UPDATE_ADS_ERROR";
export const CREATE_OR_UPDATE_ADS_RESET = "CREATE_OR_UPDATE_ADS_RESET";

export const CREATE_OR_UPDATE_ADS_TYPE = "CREATE_OR_UPDATE_ADS_TYPE";
export const CREATE_OR_UPDATE_ADS_TYPE_SUCCESS = "CREATE_OR_UPDATE_ADS_TYPE_SUCCESS";
export const CREATE_OR_UPDATE_ADS_TYPE_ERROR = "CREATE_OR_UPDATE_ADS_TYPE_ERROR";
export const CREATE_OR_UPDATE_ADS_TYPE_RESET = "CREATE_OR_UPDATE_ADS_TYPE_RESET";

export const GET_ADS_TYPE = "GET_ADS_TYPE";
export const GET_ADS_TYPE_SUCCESS = "GET_ADS_TYPE_SUCCESS";
export const GET_ADS_TYPE_ERROR = "GET_ADS_TYPE_ERROR";

export const CREATE_OR_UPDATE_ADS_IMAGE_LOCATION = "CREATE_OR_UPDATE_ADS_IMAGE_LOCATION";
export const CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_SUCCESS = "CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_SUCCESS";
export const CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_ERROR = "CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_ERROR";
export const CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_RESET = "CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_RESET";

export const GET_ADS_IMAGE_LOCATION = "GET_ADS_IMAGE_LOCATION";
export const GET_ADS_IMAGE_LOCATION_SUCCESS = "GET_ADS_IMAGE_LOCATION_SUCCESS";
export const GET_ADS_IMAGE_LOCATION_ERROR = "GET_ADS_IMAGE_LOCATION_ERROR";

export const CREATE_OR_UPDATE_ADS_IMAGE_TYPE = "CREATE_OR_UPDATE_ADS_IMAGE_TYPE";
export const CREATE_OR_UPDATE_ADS_IMAGE_TYPE_SUCCESS = "CREATE_OR_UPDATE_ADS_IMAGE_TYPE_SUCCESS";
export const CREATE_OR_UPDATE_ADS_IMAGE_TYPE_ERROR = "CREATE_OR_UPDATE_ADS_IMAGE_TYPE_ERROR";
export const CREATE_OR_UPDATE_ADS_IMAGE_TYPE_RESET = "CREATE_OR_UPDATE_ADS_IMAGE_TYPE_RESET";

export const GET_ADS_IMAGE_TYPE = "GET_ADS_IMAGE_TYPE";
export const GET_ADS_IMAGE_TYPE_SUCCESS = "GET_ADS_IMAGE_TYPE_SUCCESS";
export const GET_ADS_IMAGE_TYPE_ERROR = "GET_ADS_IMAGE_TYPE_ERROR";

export const GET_AD_BANNER = "GET_AD_BANNER";
export const GET_AD_BANNER_SUCCESS = "GET_AD_BANNER_SUCCESS";
export const GET_AD_BANNER_ERROR = "GET_AD_BANNER_ERROR";

export function getAdsRecord() {
  return async (dispatch) => {
    dispatch(getAds());
    return await adsService
      .getAds()

      .then((response) => dispatch(getAdsSuccess(response.data)))
      .catch((error) => dispatch(getAdsError(error)));
  };
}

export function getAds() {
  return {
    type: GET_ADS,
  };
}

export function getAdsSuccess(success) {
  return {
    type: GET_ADS_SUCCESS,
    payload: { success },
  };
}

export function getAdsError(error) {
  return {
    type: GET_ADS_ERROR,
    payload: { error },
  };
}

// Get Ad Banner Data -- Start
export function getAdBannerRecord(query) {
  return async (dispatch) => {
    dispatch(getAdBanner());
    return await adsService
      .getAdBanner(query)
      
      .then((response) => dispatch(getAdBannerSuccess(response)))
      .catch((error) => dispatch(getAdBannerError(error)));
  };
}

export function getAdBanner() {
  return {
    type: GET_AD_BANNER,
  };
}

export function getAdBannerSuccess(success) {
  return {
    type: GET_AD_BANNER_SUCCESS,
    payload: { success },
  };
}

export function getAdBannerError(error) {
  return {
    type: GET_AD_BANNER_ERROR,
    payload: { error },
  };
}
// Get Ad Banner Data -- End

export function createOrUpdateAdsRecord(data) {
  return async (dispatch) => {
    dispatch(createOrUpdateAds());
    return await adsService
      .createOrUpdateAds(data)
      
      .then((response) => dispatch(createOrUpdateAdsSuccess(response)))
      .catch((error) => dispatch(createOrUpdateAdsError(error)));
  };
}

export function createOrUpdateAds() {
  return {
    type: CREATE_OR_UPDATE_ADS,
  };
}

export function createOrUpdateAdsSuccess(success) {
  return {
    type: CREATE_OR_UPDATE_ADS_SUCCESS,
    payload: { success },
  };
}

export function createOrUpdateAdsError(error) {
  return {
    type: CREATE_OR_UPDATE_ADS_ERROR,
    payload: { error },
  };
}

export function createOrUpdateAdsReset() {
  return {
    type: CREATE_OR_UPDATE_ADS_RESET,
  };
}

// Add Or Edit Ads Type -- Start
export function createOrUpdateAdsTypeRecord(data) {
  return async (dispatch) => {
    dispatch(createOrUpdateAdsType());
    return await adsService
      .createOrUpdateAdsType(data)
      
      .then((response) => dispatch(createOrUpdateAdsTypeSuccess(response)))
      .catch((error) => dispatch(createOrUpdateAdsTypeError(error)));
  };
}

export function createOrUpdateAdsType() {
  return {
    type: CREATE_OR_UPDATE_ADS_TYPE,
  };
}

export function createOrUpdateAdsTypeSuccess(success) {
  return {
    type: CREATE_OR_UPDATE_ADS_TYPE_SUCCESS,
    payload: { success },
  };
}

export function createOrUpdateAdsTypeError(error) {
  return {
    type: CREATE_OR_UPDATE_ADS_TYPE_ERROR,
    payload: { error },
  };
}

export function createOrUpdateAdsTypeReset() {
  return {
    type: CREATE_OR_UPDATE_ADS_TYPE_RESET,
  };
}
// Add Or Edit Ads Type -- End

// Get Ads Type -- Start
export function getAdsTypeRecord(query) {
  return async (dispatch) => {
    dispatch(getAdsType());
    return await adsService
      .getAdsType(query)
      
      .then((response) => dispatch(getAdsTypeSuccess(response)))
      .catch((error) => dispatch(getAdsTypeError(error)));
  };
}

export function getAdsType() {
  return {
    type: GET_ADS_TYPE,
  };
}

export function getAdsTypeSuccess(success) {
  return {
    type: GET_ADS_TYPE_SUCCESS,
    payload: { success },
  };
}

export function getAdsTypeError(error) {
  return {
    type: GET_ADS_TYPE_ERROR,
    payload: { error },
  };
}
// Get Ads Type -- End


// Add Or Edit Ads Image Location -- Start
export function createOrUpdateAdsImageLocationRecord(data) {
  return async (dispatch) => {
    dispatch(createOrUpdateAdsImageLocation());
    return await adsService
      .createOrUpdateAdsImageLocation(data)
      
      .then((response) => dispatch(createOrUpdateAdsImageLocationSuccess(response)))
      .catch((error) => dispatch(createOrUpdateAdsImageLocationError(error)));
  };
}

export function createOrUpdateAdsImageLocation() {
  return {
    type: CREATE_OR_UPDATE_ADS_IMAGE_LOCATION,
  };
}

export function createOrUpdateAdsImageLocationSuccess(success) {
  return {
    type: CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_SUCCESS,
    payload: { success },
  };
}

export function createOrUpdateAdsImageLocationError(error) {
  return {
    type: CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_ERROR,
    payload: { error },
  };
}

export function createOrUpdateAdsImageLocationReset() {
  return {
    type: CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_RESET,
  };
}
// Add Or Edit Ads Image Location -- End

// Get Ads Image Location -- Start
export function getAdsImageLocationRecord(query) {
  return async (dispatch) => {
    dispatch(getAdsImageLocation());
    return await adsService
      .getAdsImageLocation(query)
      
      .then((response) => dispatch(getAdsImageLocationSuccess(response)))
      .catch((error) => dispatch(getAdsImageLocationError(error)));
  };
}

export function getAdsImageLocation() {
  return {
    type: GET_ADS_IMAGE_LOCATION,
  };
}

export function getAdsImageLocationSuccess(success) {
  return {
    type: GET_ADS_IMAGE_LOCATION_SUCCESS,
    payload: { success },
  };
}

export function getAdsImageLocationError(error) {
  return {
    type: GET_ADS_IMAGE_LOCATION_ERROR,
    payload: { error },
  };
}
// Get Ads Image Location -- End

// Add Or Edit Ads Image Location -- Start
export function createOrUpdateAdsImageTypeRecord(data) {
  return async (dispatch) => {
    dispatch(createOrUpdateAdsImageType());
    return await adsService
      .createOrUpdateAdsImageType(data)
      
      .then((response) => dispatch(createOrUpdateAdsImageTypeSuccess(response)))
      .catch((error) => dispatch(createOrUpdateAdsImageTypeError(error)));
  };
}

export function createOrUpdateAdsImageType() {
  return {
    type: CREATE_OR_UPDATE_ADS_IMAGE_TYPE,
  };
}

export function createOrUpdateAdsImageTypeSuccess(success) {
  return {
    type: CREATE_OR_UPDATE_ADS_IMAGE_TYPE_SUCCESS,
    payload: { success },
  };
}

export function createOrUpdateAdsImageTypeError(error) {
  return {
    type: CREATE_OR_UPDATE_ADS_IMAGE_TYPE_ERROR,
    payload: { error },
  };
}

export function createOrUpdateAdsImageTypeReset() {
  return {
    type: CREATE_OR_UPDATE_ADS_IMAGE_TYPE_RESET,
  };
}
// Add Or Edit Ads Image Location -- End

// Get Ads Image Location -- Start
export function getAdsImageTypeRecord(query) {
  return async (dispatch) => {
    dispatch(getAdsImageType());
    return await adsService
      .getAdsImageType(query)
      
      .then((response) => dispatch(getAdsImageTypeSuccess(response)))
      .catch((error) => dispatch(getAdsImageTypeError(error)));
  };
}

export function getAdsImageType() {
  return {
    type: GET_ADS_IMAGE_TYPE,
  };
}

export function getAdsImageTypeSuccess(success) {
  return {
    type: GET_ADS_IMAGE_TYPE_SUCCESS,
    payload: { success },
  };
}

export function getAdsImageTypeError(error) {
  return {
    type: GET_ADS_IMAGE_TYPE_ERROR,
    payload: { error },
  };
}
// Get Ads Image Location -- End